import { render, staticRenderFns } from "./Proje.vue?vue&type=template&id=2d8e82e3&scoped=true&"
import script from "./Proje.vue?vue&type=script&lang=js&"
export * from "./Proje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8e82e3",
  null
  
)

export default component.exports